<template>
  <transition name="slide-y-transition" mode="out-in">
    <InputOutputContainer v-if="loaded && event" />
    <div
      v-else
      class="d-flex justify-center align-center"
      style="width: 100%; height: 100%"
    >
      <v-progress-circular :size="80" color="primary" indeterminate />
    </div>
  </transition>
</template>

<script>
import InputOutputContainer from './InputOutputContainer'
import gql from 'graphql-tag'
import { get } from 'vuex-pathify'

export default {
  name: 'InputOutputContainerLoader',

  components: {
    InputOutputContainer
  },

  computed: {
    loaded: get('event/selectedEventLoaded'),
    event: get('event/selectedEvent'),
    selectedEventUUID: get('event/selectedUUID')
  },

  apollo: {
    event: {
      query: gql`
        query event($filter: GetEventInput!) {
          duaReasonCodes {
            code
            text
          }

          event(filter: $filter) {
            delays {
              event_uuid
              uuid
              train_number
              type
              location_place
              location_time
              delay
              checked
              deleted
            }
            replacements {
              event_uuid
              uuid
              type
              train_number
              from
              to
              via
              status
              checked
              deleted
            }
            train_deviations {
              event_uuid
              uuid
              type
              train_number
              from
              to
              departure
              places
              arrival
              deviation_type
              checked
              deleted
            }
            turnarounds {
              event_uuid
              uuid
              train_number_from
              train_number_to
              location
              checked
              deleted
            }
            yellow_vests {
              event_uuid
              uuid
              assigned
              demand
              location
              checked
              deleted
            }
            crew_deviations {
              event_uuid
              uuid
              train_number
              duty_date
              deleted
              from
              to
            }
          }
        }
      `,
      manual: true,

      fetchPolicy: 'no-cache',

      result({ data }) {
        if (!data) return
        this.$store.dispatch(
          'trainDeviation/mapData',
          data.event.train_deviations
        )
        this.$store.dispatch('crew/mapData', data.event.crew_deviations)
        this.$store.dispatch('delay/mapData', data.event.delays)
        this.$store.dispatch('replacement/mapData', data.event.replacements)
        this.$store.dispatch('turnaround/mapData', data.event.turnarounds)
        this.$store.dispatch('yellowVest/mapData', data.event.yellow_vests)
        this.$store.set('duaMessage/duaReasonCodes', data.duaReasonCodes)
        this.$store.dispatch('duaMessage/setForm')
        this.$store.dispatch('smsMessage/setForm')

        this.$store.set('event/selectedEventLoaded', true)
      },
      variables() {
        return {
          filter: {
            uuid: this.selectedEventUUID
          }
        }
      }
    }
  }
}
</script>
